import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {SidePanel, stringUtils, UploadDocument} from 'front-onceforall-core';

import documentTypeService from '../../../../services/documentType/DocumentTypeService';
import {pathDocumentExamples} from '../../../../utils/path';
import {getDocumentName} from '../../../../utils/document';

function UploadDocumentPanel(props) {
  const [documentEquivalences, setDocumentEquivalences] = React.useState([]);

  function getEquivalences() {
    documentTypeService.getEquivalences(props.document.type.documentTypeId, props.organisationId)
      .then(response => {
        setDocumentEquivalences(response);
      })
      .catch(() => {
        setDocumentEquivalences([]);
      });
  }

  React.useEffect(() => {
    getEquivalences();
  }, []);

  function handleDocumentExampleOpen() {
    window.open(`${pathDocumentExamples + getDocumentName(props.document.type.name)}.pdf`);
  }

  const getMessage = () => (
    <>
      <div className="mt-5">
        {stringUtils.getStrongs(I18n.t(`document.uploadMessage.${props.document.type.country}`))}
      </div>
      {props.message}
    </>
  );

  return (
    <SidePanel
      onClose={props.onClose}
    >
      <UploadDocument
        document={props.document}
        documentEquivalences={documentEquivalences}
        onCancel={props.onClose}
        onHandleSubmitFile={props.onSubmit}
        submitted={props.submitting}
        onDocumentExampleOpen={handleDocumentExampleOpen}
        message={getMessage()}
        lockSubtype
      />
    </SidePanel>
  );
}

UploadDocumentPanel.defaultProps = {
  message: null
};

UploadDocumentPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  document: PropTypes.object,
  organisationId: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  message: PropTypes.node,
  submitting: PropTypes.bool.isRequired
};

export default UploadDocumentPanel;
